import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';

interface RoutalProps {
  color?: string;
  style?: React.CSSProperties;
}

export const RoutalIcon = ({ color = RoutalPalette.white, style = {}, ...props }: RoutalProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 9 10" style={{ width: `9px`, height: `10px`, ...style }}>
      <path
        d="M7.11293 7.0973C7.61271 6.80079 8.02386 6.37949 8.30468 5.87616C8.5855 5.37282 8.72599 4.80537 8.7119 4.23136C8.7119 2.39026 7.38347 0.883789 4.99823 0.883789H0.742676V2.58398C0.742819 3.0383 0.926332 3.47398 1.25287 3.79524C1.57942 4.11649 2.02226 4.29703 2.48406 4.29717C2.02226 4.29731 1.57942 4.47786 1.25287 4.79911C0.926332 5.12037 0.742819 5.55604 0.742676 6.01037V10.6176H3.10121V7.69862H4.9575L6.35364 10.6176H8.95601L7.11293 7.0973ZM6.46719 4.30513C6.01438 4.40232 5.59935 4.62514 5.27127 4.9472C4.94319 5.26927 4.7158 5.67708 4.61602 6.12235V6.12846L4.6109 6.11121C4.51118 5.66819 4.28513 5.26232 3.95926 4.94121C3.63339 4.6201 3.22121 4.39706 2.77106 4.29824H2.76566L2.76863 4.29611C3.22015 4.19819 3.63385 3.97544 3.96107 3.65408C4.28829 3.33272 4.51543 2.92611 4.61575 2.48208L4.61791 2.48925C4.71749 2.93177 4.94313 3.33723 5.26844 3.65817C5.59375 3.9791 6.00526 4.20223 6.45479 4.30142L6.46908 4.30434L6.46719 4.30513Z"
        fill="white"
      />
    </SvgIcon>
  );
};
